import { BaseData} from './BaseData.js';
class RenderControlData extends BaseData {
  static annotations = {
    render_control_type: String, // e.g., 'hero', 'signup_hero', 'workshop', 'learning_outcomes'
  };
}


export { RenderControlData}; // NEW
export default RenderControlData;